const globalShippingRates = {
'Cerrillos': '$7.200',
'Cerro Navia': '$7.200',
'Chicureo': '$14.100',
'Colina': '$14.100',
'Conchalí': '$5.600',
'El Bosque': '$7.200',
'Estación Central': '$5.600',
'Huechuraba': '$5.600',
'Independencia': '$5.600',
'La Cisterna': '$5.600',
'La Florida': '$9.400',
'La Granja': '$7.200',
'La Reina': '$6.500',
'Lampa': '$14.100',
'Las Condes': '$5.000',
'Lo Barnechea': '$6.500',
'Lo Espejo': '$5.600',
'Lo Prado': '$7.200',
'Macul': '$5.600',
'Maipú': '$9.400',
'Ñuñoa': '$5.000',
'Pedro Aguirre Cerda': '$7.200',
'Peñalolén': '$7.200',
'Providencia': '$5.000',
'Pudahuel': '$7.200',
'Puente Alto': '$11.500',
'Quilicura': '$5.600',
'Quinta Normal': '$7.200',
'Recoleta': '$5.600',
'Renca': '$6.500',
'San Bernardo': '$11.500',
'San Joaquín': '$7.200',
'San Miguel': '$7.200',
'San Ramón': '$7.200',
'Santiago Centro': '$5.600',
'Vitacura': '$5.000'
}
// Patrones de configuración reutilizables
const themePatterns = {
  'flores_generales': {
    filters: {
      prices: [
  { label: '$20.000 – $30.000', collection: '20000-30000' },
  { label: '$31.000 – $45.000', collection: '31000-45000' },
  { label: '$46.000 – $72.000', collection: '46000-72000' },
  { label: '$73.000+', collection: '73000-mas' }
],
      types: [
  { label: 'Alstroemerias', collection: 'alstroemerias' },
  { label: 'Condolencia', collection: 'condolencia' },
  { label: 'Colección Deluxe', collection: 'coleccion-deluxe' },
  { label: 'Gerberas', collection: 'gerberas' },
  { label: 'Girasoles', collection: 'girasoles' },
  { label: 'Liliums', collection: 'liliums' },
  { label: 'Orquídeas', collection: 'orquideas' },
  { label: 'Peonías', collection: 'peonias' },
  { label: 'Navidad', collection: 'navidad' },
  { label: 'Rosas', collection: 'rosas' },
  { label: 'Tulipanes', collection: 'tulipanes' },
  { label: 'Flores a Granel', collection: 'flores-a-granel' },
  { label: 'Proteas', collection: 'proteas' },
  { label: 'Ranúnculos', collection: 'ranunculos' }
],
      occasions: [
  { label: 'Aniversarios', collection: 'aniversarios' },
  { label: 'Cumpleaños', collection: 'cumpleanos' },
  { label: 'Día de la Madre', collection: 'dia-de-la-madre' },
  { label: 'Día de los Enamorados', collection: 'dia-de-los-enamorados' },
  { label: 'Funerales', collection: 'funerales' },
  { label: 'Matrimonios', collection: 'matrimonios' },
  { label: 'Nacimientos', collection: 'nacimientos' },
  { label: 'Navidad', collection: 'navidad' }
]
    },
    available_communes: [
  'Cerrillos',
  'Cerro Navia',
  'Colina',
  'Chicureo',
  'Conchalí',
  'El Bosque',
  'Estación Central',
  'Huechuraba',
  'Independencia',
  'La Cisterna',
  'La Florida',
  'La Granja',
  'La Pintana',
  'La Reina',
  'Lampa',
  'Las Condes',
  'Lo Barnechea',
  'Lo Espejo',
  'Lo Prado',
  'Macul',
  'Maipú',
  'Ñuñoa',
  'Padre Hurtado',
  'Pedro Aguirre Cerda',
  'Peñaflor',
  'Peñalolén',
  'Providencia',
  'Pudahuel',
  'Puente Alto',
  'Quilicura',
  'Quinta Normal',
  'Recoleta',
  'Renca',
  'San Bernardo',
  'San Joaquín',
  'San Miguel',
  'San Ramón',
  'Santiago Centro',
  'Vitacura'
] // todas las que quieras
  },
  
  'eventos_especiales': {
    filters: {
      prices: [
  { label: '$20.000 – $30.000', collection: '20000-30000' },
  { label: '$31.000 – $45.000', collection: '31000-45000' },
  { label: '$46.000 – $72.000', collection: '46000-72000' },
  { label: '$73.000+', collection: '73000-mas' }
],
      types: [
  { label: 'Alstroemerias', collection: 'alstroemerias' },
  { label: 'Condolencia', collection: 'condolencia' },
  { label: 'Colección Deluxe', collection: 'coleccion-deluxe' },
  { label: 'Gerberas', collection: 'gerberas' },
  { label: 'Girasoles', collection: 'girasoles' },
  { label: 'Liliums', collection: 'liliums' },
  { label: 'Orquídeas', collection: 'orquideas' },
  { label: 'Peonías', collection: 'peonias' },
  { label: 'Navidad', collection: 'navidad' },
  { label: 'Rosas', collection: 'rosas' },
  { label: 'Tulipanes', collection: 'tulipanes' },
  { label: 'Flores a Granel', collection: 'flores-a-granel' },
  { label: 'Proteas', collection: 'proteas' },
  { label: 'Ranúnculos', collection: 'ranunculos' }
],
     occasions: [
  { label: 'Aniversarios', collection: 'aniversarios' },
  { label: 'Cumpleaños', collection: 'cumpleanos' },
  { label: 'Día de la Madre', collection: 'dia-de-la-madre' },
  { label: 'Día de los Enamorados', collection: 'dia-de-los-enamorados' },
  { label: 'Funerales', collection: 'funerales' },
  { label: 'Matrimonios', collection: 'matrimonios' },
  { label: 'Nacimientos', collection: 'nacimientos' },
  { label: 'Navidad', collection: 'navidad' }
]
    },
   available_communes: [
  'Chicureo',
  'Colina',
  'Huechuraba',
  'Independencia',
  'La Florida',
  'La Reina',
  'Las Condes',
  'Lo Barnechea',
  'Macul',
  'Maipú',
  'Ñuñoa',
  'Peñalolén',
  'Providencia',
  'Puente Alto',
  'Recoleta',
  'San Miguel',
  'Santiago Centro',
  'Vitacura'
] // menos comunas
  }
};

// Mapeo de temáticas a patrones
const themeToPattern = {
  // Todas estas temáticas usan el patrón 'flores_generales'
'flores-a-domicilio': 'flores_generales',
'ramos-de-novia': 'flores_generales',
'arreglos-florales-para-funeral': 'flores_generales',
'rosas-a-domicilio': 'flores_generales',
'ramos-de-flores-a-domicilio': 'flores_generales',
'envio-de-flores': 'flores_generales',
'flores-de-condolencia': 'flores_generales',
'arreglos-florales': 'flores_generales',
'flores-secas': 'flores_generales',
'peonias': 'flores_generales',
'ramo-de-girasoles': 'flores_generales',
'ramo-de-tulipanes': 'flores_generales',
'dia-de-la-madre': 'flores_generales',
'envio-de-flores-a-domicilio': 'flores_generales',
'politica-de-envio': 'flores_generales',

  
  // Estas usan el patrón 'eventos_especiales'
  'tulipanes': 'eventos_especiales',
'orquideas': 'eventos_especiales',
'gerberas': 'eventos_especiales',
'ramos-de-flores': 'eventos_especiales',
'dia-de-los-enamorados': 'eventos_especiales',
'ramos-de-rosas': 'eventos_especiales',
'ramos-de-rosas-rojas': 'eventos_especiales',
'arreglos-florales-a-domicilio': 'eventos_especiales',
'ramo-de-flores-para-cumpleanos': 'eventos_especiales',
'dia-del-amor': 'eventos_especiales',
'alstroemerias': 'eventos_especiales',
'bouquet-de-flores': 'eventos_especiales',
'ramos-de-novia-naturales': 'eventos_especiales',
'arreglos-con-gerberas': 'eventos_especiales',
'tulipanes-a-domicilio': 'eventos_especiales',
'ranunculus-ranunculos': 'eventos_especiales',
'flores-a-domicilio-economicas': 'eventos_especiales',
'flores-para-regalar': 'eventos_especiales',
'orquideas-a-domicilio': 'eventos_especiales',
'flores-y-chocolate-a-domicilio': 'eventos_especiales',
'arreglo-con-girasoles': 'eventos_especiales',
'ramo-de-peonias': 'eventos_especiales',
'ramos-de-rosas-para-cumpleanos': 'eventos_especiales',
'tienda-flores': 'eventos_especiales',
'corona-de-flores': 'eventos_especiales',
'floreria-cerca-de-mi': 'eventos_especiales',
'venta-de-flores': 'eventos_especiales',
'flores-dia-de-la-madre': 'eventos_especiales',
'corona-de-flores-funebres': 'eventos_especiales',
'florerias': 'eventos_especiales',
'arreglos-florales-funebres': 'eventos_especiales',
'arreglos-flores-secas': 'eventos_especiales',
'girasoles': 'eventos_especiales',
'rosas-rojas': 'eventos_especiales',
'arreglo-floral-para-funeral': 'eventos_especiales',
'craspedias': 'eventos_especiales',
'ramo-de-flores-para-novias': 'eventos_especiales',
'flores-para-funeral': 'eventos_especiales',
'flores-rojas': 'eventos_especiales',
'los-tulipanes': 'eventos_especiales',
'peonias-flores': 'eventos_especiales',
'flores-para-condolencias': 'eventos_especiales',
'peonias-chile': 'eventos_especiales',
'flor-peonia': 'eventos_especiales',
'tulipanes-morados': 'eventos_especiales',
'peonias-rosas': 'eventos_especiales',
'flores-a-domicilio-baratas': 'eventos_especiales',
'flores-girasoles': 'eventos_especiales',
'craspedia': 'eventos_especiales',
'arreglos-florales-para-matrimonio': 'eventos_especiales',
'arreglos-florales-con-girasoles': 'eventos_especiales',
'coronas-navidenas': 'eventos_especiales',
'floreria-santiago': 'eventos_especiales',
'orquideas-blancas': 'eventos_especiales',
'ramo-girasoles': 'eventos_especiales',
'ramo-novia': 'eventos_especiales',
'arreglos-florales-para-cumpleanos': 'eventos_especiales',
'flores-funeral': 'eventos_especiales',
'mercado-de-flores-santiago': 'eventos_especiales',
'orquideas-flores': 'eventos_especiales',
'ramo-tulipanes': 'eventos_especiales',
'ramos-de-novia-flores-naturales': 'eventos_especiales',
'rosa-peonia': 'eventos_especiales',
'tulipanes-de-colores': 'eventos_especiales',
'arreglos-con-girasoles': 'eventos_especiales',
'arreglos-florales-a-domicilio-santiago': 'eventos_especiales',
'coronas-de-condolencias': 'eventos_especiales',
'florerias-en-santiago': 'eventos_especiales',
'flores-para-cumpleanos': 'eventos_especiales',
'ramos-de-flores-hermosas': 'eventos_especiales',
'ramo-rosas': 'eventos_especiales',
'orquideas-naturales': 'eventos_especiales',
'ranunculos': 'eventos_especiales',
'orquideas-chile': 'eventos_especiales',
'girasoles-flores': 'eventos_especiales',
'gerberas-flores': 'eventos_especiales',
'flores-blancas': 'eventos_especiales',
'floristeria': 'eventos_especiales',
'regalos-dia-de-la-madre': 'eventos_especiales',
'tulipanes-chile': 'eventos_especiales',
'tulipan-amarillo': 'eventos_especiales',
'arreglo-floral-a-domicilio': 'eventos_especiales',
'rosas-colores': 'eventos_especiales',
'floreria-en-santiago': 'eventos_especiales',
'rosas-blancas': 'eventos_especiales',
'flor-tulipan': 'eventos_especiales',
'tulipanes-amarillos': 'eventos_especiales',
'corona-de-flores-funeral': 'eventos_especiales',
'corona-flores': 'eventos_especiales',
'coronas-de-flores-a-domicilio': 'eventos_especiales',
'floreria-a-domicilio': 'eventos_especiales',
'flores-para-velorio': 'eventos_especiales',
'floristerias': 'eventos_especiales',
'orquidea': 'eventos_especiales',
'flores-tienda': 'eventos_especiales',
'tienda-en-flores': 'eventos_especiales',
'floreria': 'eventos_especiales',
'terminas-de-flores': 'eventos_especiales',
'peonidas': 'eventos_especiales',
'ramos-de-novias': 'eventos_especiales',
'florerias-a-domicilio': 'eventos_especiales',
'flores-amarillas': 'eventos_especiales',
'peonia': 'eventos_especiales',
'flores-navidenas': 'eventos_especiales',
'flores-de-navidad': 'eventos_especiales',
'flores-navidad': 'eventos_especiales',
'coronas-de-navidad': 'eventos_especiales',
'flor-amarilla': 'eventos_especiales',
'feliz-dia-del-amor-y-la-amistad': 'eventos_especiales',
'dia-del-amor-y-la-amistad': 'eventos_especiales',
'claveles': 'eventos_especiales',
'maule-flor': 'eventos_especiales',
'regalos-de-navidad': 'eventos_especiales',
'alstroemeria': 'eventos_especiales',
'ramo-de-novias-naturales': 'eventos_especiales',
'girasoles-ramo': 'eventos_especiales',
'astromelias': 'eventos_especiales',
'flores-rosadas': 'eventos_especiales',
'flores-y-rosas': 'eventos_especiales',
'flores-cerca-de-mi': 'eventos_especiales',
'ramo-de-flores-amarillas': 'eventos_especiales',
'flores-secas-decorativas': 'eventos_especiales',
'regalos-para-el-dia-de-los-enamorados': 'eventos_especiales',
'floreria-14-de-febrero': 'eventos_especiales',
'flores-a-domicilio-14-de-febrero': 'eventos_especiales',
'flores-para-dia-del-amor': 'eventos_especiales',
'flores-san-valentin': 'eventos_especiales',
'hortensia': 'eventos_especiales',
'ramo-de-rosas': 'eventos_especiales',
'flores-del-dia-del-amor-y-la-amistad': 'eventos_especiales',
'regalos-para-el-dia-de-las-madres': 'eventos_especiales',
'regalos-para-mama': 'eventos_especiales',
'regalos-para-el-dia-de-la-madre': 'eventos_especiales',
'dia-de-las-madres-regalos': 'eventos_especiales',
'para-regalar-a-mama': 'eventos_especiales',
'dia-de-las-madres': 'eventos_especiales',
'feliz-dia-de-la-mujer': 'eventos_especiales',
  
  // Configuración específica única
  'flores-funeral': {
    filters: {
      types: [{ label: 'Coronas', collection: 'coronas' }]
    },
    available_communes: ['Santiago Centro'] // solo esta comuna
  }
};

// Función que obtiene la configuración
function getThemeConfig(pageHandle) {
  // Extraer la base temática (sin comuna al final)
  const themeBase = extractThemeBase(pageHandle);

  // Buscar coincidencia EXACTA en el mapeo
  if (themeToPattern[themeBase]) {
    const config = themeToPattern[themeBase];
    if (typeof config === 'string') {
      return themePatterns[config];
    }
    return config;
  }

  // Fallback - páginas nuevas usan eventos_especiales automáticamente
  return themePatterns['eventos_especiales'];
}
// Lista de comunas normalizadas (slug format) para detectar en URLs
const communeSlugs = [
  'cerrillos', 'cerro-navia', 'chicureo', 'colina', 'conchali', 'el-bosque',
  'estacion-central', 'huechuraba', 'independencia', 'la-cisterna', 'la-florida',
  'la-granja', 'la-pintana', 'la-reina', 'lampa', 'las-condes', 'lo-barnechea',
  'lo-espejo', 'lo-prado', 'macul', 'maipu', 'nunoa', 'padre-hurtado',
  'pedro-aguirre-cerda', 'penaflor', 'penalolen', 'providencia', 'pudahuel',
  'puente-alto', 'quilicura', 'quinta-normal', 'recoleta', 'renca',
  'san-bernardo', 'san-joaquin', 'san-miguel', 'san-ramon', 'santiago-centro', 'vitacura'
];

// Función que extrae la base temática del pageHandle removiendo la comuna del final
function extractThemeBase(pageHandle) {
  console.log('pageHandle recibido:', pageHandle); // DEBUG - borrar después
  for (const comunaSlug of communeSlugs) {
    if (pageHandle.endsWith('-' + comunaSlug)) {
      const base = pageHandle.slice(0, -(comunaSlug.length + 1));
      console.log('Base extraída:', base); // DEBUG - borrar después
      return base;
    }
  }
  // Si no termina en comuna, retornar el handle completo
  console.log('Sin comuna, retornando handle completo:', pageHandle); // DEBUG - borrar después
  return pageHandle;
}

// Función que combina tarifas globales con comunas disponibles
function getShippingRatesForTheme(themeConfig, pageHandle) {
  const availableRates = {};

  // Extraer la base temática del pageHandle automáticamente
  const themeKey = extractThemeBase(pageHandle);

  themeConfig.available_communes.forEach(comuna => {
    if (globalShippingRates[comuna]) {
      availableRates[comuna] = {
        precio: globalShippingRates[comuna],
        url: `/pages/${themeKey}-${comuna.toLowerCase().replace(/\s+/g, '-').replace('ñ', 'n')}`
      };
    }
  });

  return availableRates;
}